import { format, parseISO } from 'date-fns';
import { FC } from 'react';
import { connect } from 'react-redux';
import Helper from '../../modules/Helper';

type CarDetailCardProps = {
	ticketData: any;
};
const CarDetailCard: FC<CarDetailCardProps> = ({ ticketData }) => {
	const getReturnInfo = () => {
		const dropOffTime = parseISO(ticketData['drop-off-time']);

		return (
			<div className="info">
				<span className="name">{Helper.trans('keywords.dropOffLocation')}</span>
				<span className="location">{getDestination(getDropOffDestination())}</span>
				<span className="time">{format(dropOffTime, ' DD MMMM YYYY')}</span>
			</div>
		);
	};

	const getDropOffDestination = () => {
		if (ticketData.hasOwnProperty('drop-off-destination')) {
			return ticketData['drop-off-destination'];
		}
		return ticketData['pickup-destination'];
	};
	const getDestination = (code: string) => {
		if (code.length === 3) {
			return code;
		}
		if (code.search(',') !== -1) {
			return code.split(',')[0];
		}
	};

	if (Helper.isEmpty(ticketData)) {
		return <></>;
	}

	const departureTime = parseISO(ticketData['pickup-time']);

	return (
		<div id="detail-card">
			<h3 id="title">{Helper.trans('keywords.rentalDetails')}</h3>
			<div className="mt-3 mb-3">
				<div className="info">
					<span className="name">{Helper.trans('keywords.pickUpLocation')}</span>
					<span className="location">{getDestination(ticketData['pickup-destination'])}</span>
					<span className="time">{format(departureTime, ' DD MMMM YYYY')}</span>
				</div>
				{getReturnInfo()}
			</div>
		</div>
	);
};

// @ts-ignore
const mapStateToProps = (state) => ({
	ticketData: state.passthru.ticketData,
});
export default connect(mapStateToProps, {})(CarDetailCard);
